import React from 'preact/compat';
import { h, render } from 'preact';
import './style/index.less';
import { CookiesProvider } from 'react-cookie';
import App from './components/app';

if (typeof window !== 'undefined') {
    render(<CookiesProvider><App /></CookiesProvider>, document.getElementById('app-container'));
}
